export default __webpack_public_path__ + "static/media/Plumbers.3933bdbe.png";